export interface Religion {
  religion: Array<{
    text: string,
    value: string,
  }>
}

export function getReligion(): Religion {
  return {
    religion: [
      { text: 'ไม่ระบุ', value: 'ไม่ระบุ' },
      { text: 'พุทธ', value: 'พุทธ' },
      { text: 'คริสต์', value: 'คริส' },
      { text: 'อิสลาม', value: 'อิสลาม' },
      { text: 'ฮินดู', value: 'ฮินดู' },
      { text: 'ซิกข์', value: 'ซิกข์' },
    ],
  }
}
